import { Card } from "@scuf/common";
import { Chart } from "@scuf/charts";
import { useEffect, useState } from "react";
import { TostadorFetching } from "../../../class/fetchTostador";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";
import { useDate } from "../../../hooks/useDate";

export default function SiliceInsolublesConALim() {
  // Objecto default del state
  const defaultObject = Object.assign({
    value: [],
    fecha: [],
  });

  // Peticion inicial de esta grafica
  const initialFetch = new TostadorFetching()
    .setIdSeccion(8)
    .setSecuencia(3)
    .setFrecuencia(720)
    .setDias(7);

      // Custom hook que nos ayuda a extraer la fecha inicial y final
  const { setDateHook, fullDate } = useDate();

  const [insolublesConAlim, setInsolublesConAlim] = useState(defaultObject);
  const [limiteInsolublesCon, setLimiteInsolublesCon] = useState(defaultObject);
  const [sio2ConcentradoAlim, setSio2ConcentradoAlim] = useState(defaultObject);

  useEffect(() => {
    async function fetchData() {
      const { data } = await getValoresPeriodo(initialFetch);

      populateInsolublesConAlim(data);
      populateLimiteInsoCon(data);
      populateSio2ConAlim(data);
      setDateHook(data, "Conc_Alim_SiO2");
      setTimeout(() => {
        fetchData();
      }, 300000);
    }

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populateSio2ConAlim(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Conc_Alim_SiO2"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setSio2ConcentradoAlim({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateLimiteInsoCon(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "SIO2_CONC.LIMIT"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setLimiteInsolublesCon({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateInsolublesConAlim(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Conc_Alim_Insolubles"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setInsolublesConAlim({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  return (
    <>
      <Card>
        <Card.Content>
          <Chart
            title="Silice e Insolubles Concentrado Alimentado - Reporte"
            subtitle={"Periodo " + fullDate()}
            zoom="x"
          >
            <Chart.Column
              name="%Insolubles Concentrado Alimentado"
              data={insolublesConAlim.value}
            />

            <Chart.Line
              name="Limite Insolubles Concentrado"
              data={limiteInsolublesCon.value}
            />

            <Chart.Column
              name="%SiO2 Concentrado Alimentado - Reporte"
              data={sio2ConcentradoAlim.value}
            />

            <Chart.XAxis allowDecimals={false} categories={insolublesConAlim.fecha} />
            <Chart.YAxis
              labelSuffix=" %"
              title="Contenido, %"
              lineWidth={2}
              lineColor="white"
              min={0}
            />

            <Chart.YAxis labelSuffix=" %" />
            <Chart.Tooltip valueSuffix=" %" />
          </Chart>
        </Card.Content>
      </Card>
    </>
  );
}
